angular.module('eficienciaFiscalModule')
    .component('modal', {
        transclude: {
            body: 'modalBody',
            footer: '?modalFooter'
        },
        bindings: {
            title: '@',
            modalTitle: '@',
            close: '<'
        },
        controller: ['$transclude', function($transclude) {
            this.hasFooter = $transclude.isSlotFilled('footer')
        }],
        template: `
            <div class="modal-header" ng-if="$ctrl.modalTitle || $ctrl.title">
                <h3 class="modal-title">
                    {{ $ctrl.modalTitle || $ctrl.title }}
                    <i class="fa fa-times pull-right cursor-pointer" tooltip="Fechar" ng-click="$ctrl.close()"></i>
                </h3>
            </div>
            <div ng-transclude="body" class="modal-body"></div>
            <div ng-transclude="footer" ng-if="$ctrl.hasFooter" class="modal-footer"></div>
        `
    })
